import { createContext } from 'react';

export const OnCloseContext = createContext<(() => void) | undefined>(undefined);
